import React from 'react';
import { CircularProgress, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useLimitations } from './useLimitations';
import LimitationsContent from './LimitationsContent';
import DraggableDialog from '../../../Dialogs/DraggableDialog/DraggableDialog';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#3a3a3a61',
  },
}));

export default function LimitationsDialog({ open, onClose }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const {
    limitations,
    newTitle,
    newDescription,
    isSaving,
    hasChanges,
    showAddSection,
    handleToggle,
    handleDelete,
    handleAdd,
    handleSave,
    handleClose,
    handleToggleAddSection,
    setNewTitle,
    setNewDescription,
    resetAddForm,
  } = useLimitations(open, onClose);

  return (
    <DraggableDialog
      maxWidth='md'
      title={t('ResultView.Notes')}
      open={open}
      actions={[
        {
          onClick: handleClose,
          color: 'primary',
          label: t('export.cancel'),
        },
        {
          onClick: handleSave,
          color: 'primary',
          label: t('export.save'),
          disabled: isSaving || !hasChanges,
        },
      ]}
      onClose={handleClose}>
      {isSaving && (
        <Box className={classes.loadingContainer}>
          <CircularProgress size={24} />
        </Box>
      )}

      <LimitationsContent
        limitations={limitations}
        newTitle={newTitle}
        newDescription={newDescription}
        showAddSection={showAddSection}
        handleToggle={handleToggle}
        handleDelete={handleDelete}
        handleAdd={handleAdd}
        handleToggleAddSection={handleToggleAddSection}
        setNewTitle={setNewTitle}
        setNewDescription={setNewDescription}
        resetAddForm={resetAddForm}
        variant='dialog'
      />
    </DraggableDialog>
  );
}
